import { colors, makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  formControlLabelRootGroup: {
    margin: 0,
    paddingLeft: 3,
  },
  formControlLabelRoot: {
    margin: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  formControlLabelGroup: {
    fontWeight: theme.typography.h6.fontWeight,
    fontSize: theme.typography.h6.fontSize,
  },
  checked: {
    backgroundColor: colors.grey[100],
  },
}))

export default styles
